module.exports = __webpack_public_path__ + "img/IMGP8617b.bf049dfe.jpg";